import cookieHelper from "@irati/utils/cookies";
export default function getCookie(COOKIE_NAME) {
    try {
        var version = cookieHelper.getItem(COOKIE_NAME) || "";
        return version;
    }
    catch (e) {
        return "";
    }
}
